<template>
    <div class="wrapper">
        <div 
          class="bay_window"
          v-if="0"
          @mouseover.stop="mouseover"
          @mouseout.stop="mouseout" 
          :style="{top: top + 'px', left: left + 'px'}">
          <div class="close_btn" @click.stop="close">关闭</div>
          <div @click.stop="openUrl" class="link">中国汽车工业协会培训开始报名：“全球合规视角下的中国汽车企业可持续尽责管理”</div>
        </div>
        <v-head></v-head>
<!--        <v-sidebar></v-sidebar>-->
<!--        <div class="content-box" :class="{'content-collapse':collapse}">-->
<!--            <v-tags></v-tags>-->
            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>
            </div>
<!--        </div>-->
        <!-- –––––––––––––––[ PAGE CONTENT ]––––––––––––––– -->
<!--        <main id="mainContent" class="main-content bg-gray">-->
<!--            <div class="page-container ptb-10">-->
<!--                <div class="container">-->
<!--                    <div class="section deals-header-area ptb-30">-->
<!--                        <div class="row row-tb-20">-->
<!--                            <div class="col-xs-12 col-md-4 col-lg-3" style="width: 20%;">-->
<!--                                <aside>-->
<!--                                    <ul class="nav-coupon-category panel">-->
<!--                                        <li><a href="#"><i class="fa fa-home"></i>部委</a>-->
<!--                                        </li>-->
<!--                                        <li><a href="#home?agency_id=1"><i class="fa"></i>国务院</a></li>-->
<!--                                        <li><a href="agency_id=4"><i class="fa"></i>发展改革委办公厅</a></li>-->
<!--                                        <li><a href="agency_id=3"><i class="fa"></i>生态环境部</a></li>-->
<!--                                        <li><a href="#"><i class="fa fa-image"></i>地区</a>-->
<!--                                        </li>-->
<!--                                        <li><a href="?area_id=10"><i class="fa"></i>安徽省</a></li>-->
<!--                                        <li><a href="?area_id=11"><i class="fa"></i>福建省</a></li>-->
<!--                                        <li><a href="?area_id=12"><i class="fa"></i>江西省</a></li>-->
<!--                                        <li><a href="#"><i class="fa fa-bolt"></i>关键词</a>-->
<!--                                        </li>-->
<!--                                        <li><a href="?tag_id=25"><i class="fa"></i>碳核查</a></li>-->
<!--                                        <li><a href="?tag_id=13"><i class="fa"></i>交通运输</a></li>-->
<!--                                        <li><a href="?tag_id=17"><i class="fa"></i>碳交易</a></li>-->
<!--&lt;!&ndash;                                        <li><a href="#"><i class="fa fa-image"></i>Furniture<span>50</span></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </li>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <li><a href="#"><i class="fa fa-umbrella"></i>Fashion<span>33</span></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </li>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <li><a href="#"><i class="fa fa-shopping-cart"></i>Shopping<span>37</span></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </li>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <li><a href="#"><i class="fa fa-home"></i>Home &amp; Graden<span>30</span></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </li>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <li><a href="#"><i class="fa fa-plane"></i>Travel<span>48</span></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </li>&ndash;&gt;-->
<!--                                        <li class="all-cat">-->
<!--                                            <a class="font-14" href="#">所有类目</a>-->
<!--                                        </li>-->
<!--                                    </ul>-->
<!--                                </aside>-->
<!--                            </div>-->
<!--                            <div class="col-xs-12 col-md-8 col-lg-9">-->
<!--&lt;!&ndash;                                <div class="header-deals-slider owl-slider" data-loop="true" data-autoplay="true" data-autoplay-timeout="10000" data-smart-speed="1000" data-nav-speed="false" data-nav="true" data-xxs-items="1" data-xxs-nav="true" data-xs-items="1" data-xs-nav="true" data-sm-items="1" data-sm-nav="true" data-md-items="1" data-md-nav="true" data-lg-items="1" data-lg-nav="true">&ndash;&gt;-->

<!--&lt;!&ndash;                                    <div class="deal-single panel item">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <figure class="deal-thumbnail embed-responsive embed-responsive-16by9" data-bg-img="assets/images/deals/deal_01.jpg">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="label-discount top-10 right-10">-50%</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                            <ul class="deal-actions top-10 left-10">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <li class="like-deal">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <span>&ndash;&gt;-->
<!--&lt;!&ndash;			                                            <i class="fa fa-heart"></i>&ndash;&gt;-->
<!--&lt;!&ndash;			                                        </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </li>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <li class="share-btn">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <div class="share-tooltip fade">&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <a target="_blank" href="#"><i class="fa fa-facebook"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <a target="_blank" href="#"><i class="fa fa-twitter"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <a target="_blank" href="#"><i class="fa fa-google-plus"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <a target="_blank" href="#"><i class="fa fa-pinterest"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <span><i class="fa fa-share-alt"></i></span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </li>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <li>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <span>&ndash;&gt;-->
<!--&lt;!&ndash;			                                            <i class="fa fa-camera"></i>&ndash;&gt;-->
<!--&lt;!&ndash;			                                        </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </li>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </ul>&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="deal-about p-20 pos-a bottom-0 left-0">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="rating mb-10">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <span class="rating-stars" data-rating="5">&ndash;&gt;-->
<!--&lt;!&ndash;			                                            <i class="fa fa-star-o star-active"></i>&ndash;&gt;-->
<!--&lt;!&ndash;			                                            <i class="fa fa-star-o"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <i class="fa fa-star-o"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                                                        <i class="fa fa-star-o"></i>&ndash;&gt;-->
<!--&lt;!&ndash;			                                             <i class="fa fa-star-o"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <span class="rating-reviews color-light">&ndash;&gt;-->
<!--&lt;!&ndash;			                                    	( <span class="rating-count">241</span> Reviews )&ndash;&gt;-->
<!--&lt;!&ndash;                                                    </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <h3 class="deal-title mb-10 ">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <a href="deal_single.html" class="color-light color-h-lighter">The Crash Bad Instant Folding Twin Bed</a>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </h3>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </figure>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                                <div class="owl-item active" style="width: 700px;background-color: #fff;">-->
<!--                                    <div class="carousel_items">-->
<!--                                        <div class="widget-header widget-header-style-1 position-relative mb-30" style="color:#889097;font-size: 1.35rem;margin-bottom: 10px;">-->
<!--                                            <h5 class="widget-title">相关政策</h5>-->
<!--                                        </div>-->
<!--                                        <div class="single_post widgets_small widgets_type4" v-for="(policy;
index) in policies" :key="index">-->
<!--&lt;!&ndash;                                            <div class="post_img number">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <h2>1</h2>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->
<!--                                            <div class="single_post_text">-->
<!--&lt;!&ndash;                                                <div class="meta2">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <a href="#">{{policy.agency_name}}</a>&nbsp;&nbsp;<a href="#">{{formatDate(policy.publish_date)}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </div>&ndash;&gt;-->
<!--                                                <div class="space-15"></div>-->
<!--                                                <h4><a :href="policy.source_link">{{policy.title}}</a></h4>-->
<!--                                                <h6><a :href="policy.source_link">{{policy.title_en}}</a></h6>-->
<!--                                                <ul class="inline socail_share">-->
<!--                                                    <li style="width: 60%;">-->
<!--&lt;!&ndash;                                                        <a href="#">浏览:<i class="fab fa-twitter"></i>2.2K</a>&ndash;&gt;-->
<!--                                                    </li>-->
<!--                                                    <li style="width: 40%;text-align: right;">-->
<!--                                                        <a href="#"><i class="fab fa-twitter"></i>{{policy.agency_name}}</a>&nbsp;&nbsp;<a href="#">{{formatDate(policy.publish_date)}}</a>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                                <div class="space-15"></div>-->
<!--                                                <div class="border_black"></div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="space-15"></div>-->
<!--&lt;!&ndash;                                        <div class="single_post widgets_small widgets_type4">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="post_img number">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <h2>1</h2>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="single_post_text">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="meta2">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <a href="#">TECHNOLOGY</a><a href="#">March 26,2020</a>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <h4><a href="post1.html">Nancy zhang a chinese busy woman and dhaka</a></h4>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <ul class="inline socail_share">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <li><a href="#"><i class="fab fa-twitter"></i>2.2K</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <li><a href="#"><i class="fab fa-facebook-f"></i>2.2K</a></li>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </ul>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="space-15"></div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="border_black"></div>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="space-15"></div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="single_post widgets_small widgets_type4">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="post_img number"><h2>2</h2></div><div class="single_post_text"><div class="meta2"><a href="#">TECHNOLOGY</a><a href="#">March 26,2020</a></div><h4><a href="post1.html">Harbour amid a Slowen down in singer city</a></h4><ul class="inline socail_share"><li><a href="#"><i class="fab fa-twitter"></i>2.2K</a></li><li><a href="#"><i class="fab fa-facebook-f"></i>2.2K</a></li></ul><div class="space-15"></div><div class="border_black"></div></div></div><div class="space-15"></div><div class="single_post widgets_small widgets_type4"><div class="post_img number"><h2>3</h2></div><div class="single_post_text"><div class="meta2"><a href="#">TECHNOLOGY</a><a href="#">March 26,2020</a></div><h4><a href="post1.html">Cheap smartphone sensor could help you old food safe</a></h4><ul class="inline socail_share"><li><a href="#"><i class="fab fa-twitter"></i>2.2K</a></li><li><a href="#"><i class="fab fa-facebook-f"></i>2.2K</a></li></ul><div class="space-15"></div><div class="border_black"></div></div></div><div class="space-15"></div><div class="single_post widgets_small widgets_type4"><div class="post_img number"><h2>4</h2></div><div class="single_post_text"><div class="meta2"><a href="#">TECHNOLOGY</a><a href="#">March 26,2020</a></div><h4><a href="post1.html">Nancy zhang a chinese busy woman and dhaka</a></h4><ul class="inline socail_share"><li><a href="#"><i class="fab fa-twitter"></i>2.2K</a></li><li><a href="#"><i class="fab fa-facebook-f"></i>2.2K</a></li></ul><div class="space-15"></div><div class="border_black"></div></div></div><div class="space-15"></div><div class="single_post widgets_small widgets_type4"><div class="post_img number"><h2>5</h2></div><div class="single_post_text"><div class="meta2"><a href="#">TECHNOLOGY</a><a href="#">March 26,2020</a></div><h4><a href="post1.html">The secret to moving this ancient sphinx screening</a></h4><ul class="inline socail_share"><li><a href="#"><i class="fab fa-twitter"></i>2.2K</a></li><li><a href="#"><i class="fab fa-facebook-f"></i>2.2K</a></li></ul><div class="space-15"></div><div class="border_black"></div></div></div>&ndash;&gt;-->

<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <section class="section latest-news-area blog-area blog-grid blog-3-col ptb-30">-->
<!--                        <header class="panel ptb-15 prl-20 pos-r mb-30">-->
<!--                            <h3 class="section-title font-18">碳排放政策热点</h3>-->
<!--                            <a href="blog_classic_right_sidebar.html" class="btn btn-o btn-xs pos-a right-10 pos-tb-center">Visit Blog</a>-->
<!--                        </header>-->

<!--                        <div class="row row-tb-20">-->

<!--                            &lt;!&ndash; Blog Post &ndash;&gt;-->
<!--                            <div class="blog-post col-xs-12 col-sm-6 col-md-4">-->
<!--                                <article class="entry panel">-->
<!--                                    <figure class="entry-media post-thumbnail embed-responsive embed-responsive-16by9" data-bg-img="assets/images/blog/post_01.jpg">-->
<!--                                        <div class="entry-date">-->
<!--                                            <h4>13</h4>-->
<!--                                            <h6>JUN</h6>-->
<!--                                        </div>-->
<!--                                    </figure>-->
<!--                                    <div class="entry-wrapper pt-20 pb-10 prl-20">-->
<!--                                        <header class="entry-header">-->
<!--                                            <h4 class="entry-title mb-10 mb-md-15 font-xs-16 font-sm-18 font-md-16 font-lg-16">-->
<!--                                                <a href="blog_single_standard.html">Restaurant Employer Read Clients Orders On His iPad</a>-->
<!--                                            </h4>-->
<!--                                            <div class="entry-meta mb-10">-->
<!--                                                <ul class="tag-info list-inline">-->
<!--                                                    <li><i class="icon fa fa-user"></i> By : John Doe</li>-->
<!--                                                    <li><i class="icon fa fa-comments"></i>14 Comments </li>-->
<!--                                                </ul>-->
<!--                                            </div>-->
<!--                                        </header>-->
<!--                                        <div class="entry-content">-->
<!--                                            <p class="entry-summary">Vivamus sem massa, cursus at mollis eu, euismod id risus. Vestibulum nunc ante, sagittis ut nisl at, porta porttitor justo. Nam imperdiet im...</p>-->
<!--                                        </div>-->
<!--                                        <footer class="entry-footer text-right">-->
<!--                                            <a href="blog_single_standard.html" class="more-link btn btn-link">Continue reading <i class="icon fa fa-long-arrow-right"></i></a>-->
<!--                                        </footer>-->
<!--                                    </div>-->
<!--                                </article>-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Blog Post &ndash;&gt;-->

<!--                            &lt;!&ndash; Blog Post &ndash;&gt;-->
<!--                            <div class="blog-post col-xs-12 col-sm-6 col-md-4">-->
<!--                                <article class="entry panel">-->
<!--                                    <figure class="entry-media embed-responsive embed-responsive-16by9">-->
<!--                                        <iframe src="http://www.bootstrapmb.com" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>-->
<!--                                        <div class="entry-date">-->
<!--                                            <h4>13</h4>-->
<!--                                            <h6>JUN</h6>-->
<!--                                        </div>-->
<!--                                    </figure>-->
<!--                                    <div class="entry-wrapper pt-20 pb-10 prl-20">-->
<!--                                        <header class="entry-header">-->
<!--                                            <h4 class="entry-title mb-10 mb-md-15 font-xs-16 font-sm-18 font-md-16 font-lg-16">-->
<!--                                                <a href="blog_single_vimeo.html">Amazing Classic Interior Design With Perfect Lighting</a>-->
<!--                                            </h4>-->
<!--                                            <div class="entry-meta mb-10">-->
<!--                                                <ul class="tag-info list-inline">-->
<!--                                                    <li><i class="icon fa fa-user"></i> By : John Doe</li>-->
<!--                                                    <li><i class="icon fa fa-comments"></i> 14 Comments </li>-->
<!--                                                </ul>-->
<!--                                            </div>-->
<!--                                        </header>-->
<!--                                        <div class="entry-content">-->
<!--                                            <p class="entry-summary">Vivamus sem massa, cursus at mollis eu, euismod id risus. Vestibulum nunc ante, sagittis ut nisl at, porta porttitor justo. Nam imperdiet im...</p>-->
<!--                                        </div>-->
<!--                                        <footer class="entry-footer text-right">-->
<!--                                            <a href="blog_single_vimeo.html" class="more-link btn btn-link">Continue reading <i class="icon fa fa-long-arrow-right"></i></a>-->
<!--                                        </footer>-->
<!--                                    </div>-->
<!--                                </article>-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Blog Post &ndash;&gt;-->

<!--                            &lt;!&ndash; Blog Post &ndash;&gt;-->
<!--                            <div class="blog-post col-xs-12 col-sm-6 col-md-4">-->
<!--                                <article class="entry panel">-->
<!--                                    <figure class="entry-media embed-responsive embed-responsive-16by9">-->
<!--                                        <iframe src="http://www.bootstrapmb.com" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>-->
<!--                                        <div class="entry-date">-->
<!--                                            <h4>13</h4>-->
<!--                                            <h6>JUN</h6>-->
<!--                                        </div>-->
<!--                                    </figure>-->
<!--                                    <div class="entry-wrapper pt-20 pb-10 prl-20">-->
<!--                                        <header class="entry-header">-->
<!--                                            <h4 class="entry-title mb-10 mb-md-15 font-xs-16 font-sm-18 font-md-16 font-lg-16">-->
<!--                                                <a href="blog_single_youtube.html">English Breakfast Tea With Tasty Donut Desserts</a>-->
<!--                                            </h4>-->
<!--                                            <div class="entry-meta mb-10">-->
<!--                                                <ul class="tag-info list-inline">-->
<!--                                                    <li><i class="icon fa fa-user"></i> By : John Doe</li>-->
<!--                                                    <li><i class="icon fa fa-comments"></i> 14 Comments </li>-->
<!--                                                </ul>-->
<!--                                            </div>-->
<!--                                        </header>-->
<!--                                        <div class="entry-content">-->
<!--                                            <p class="entry-summary">Vivamus sem massa, cursus at mollis eu, euismod id risus. Vestibulum nunc ante, sagittis ut nisl at, porta porttitor justo. Nam imperdiet im...</p>-->
<!--                                        </div>-->
<!--                                        <footer class="entry-footer text-right">-->
<!--                                            <a href="blog_single_youtube.html" class="more-link btn btn-link">Continue reading <i class="icon fa fa-long-arrow-right"></i></a>-->
<!--                                        </footer>-->
<!--                                    </div>-->
<!--                                </article>-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Blog Post &ndash;&gt;-->

<!--                        </div>-->
<!--                    </section>-->
<!--                </div>-->
<!--            </div>-->
<!--        </main>-->
        <footer id="mainFooter" class="main-footer" style="height: 82px;">
            <div class="container" style="text-align: left;">
                <div class="row" style="padding-left: 15px;">
                    <p style="height: 8px;margin-top: 4px;">{{$t('i18n.contacts_mode')}}：<a href="https://www.goldenbeechina.com" target="_blank">{{$t('i18n.company_name')}}</a>, <a href="mailto:carbon@goldenbeechina.com" target="_blank">{{$t('i18n.contacts_email')}}</a>, {{$t('i18n.contacts_telephone')}}</p>
                    <p style="height: 8px;">{{$t('i18n.address_name')}}：{{$t('i18n.address')}}</p>
                    <p style="height: 8px;">{{$t('i18n.filing_name')}}：<a href="https://beian.miit.gov.cn/" target="_blank">{{$t('i18n.filing_site')}}</a>&nbsp;&nbsp;<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039515" style="display:inline-block;text-decoration:none;"><img src="https://goldenbeethinktank.com/upload/portal/gaba.png" style="margin-bottom: 3px;">{{$t('i18n.filing_public')}}</a></p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import vHead from './Header.vue';
//    import vSidebar from './Sidebar.vue';
//    import vTags from './Tags.vue';
    import bus from './bus';
    import util from '../../common/js/util';
    import {getPolicyList} from '../../api/api';
    export default {
        data(){
            return {
                tagsList: [],
                collapse: false,
                sels: [],//列表选中列
                listPolicyLoading: false,
                top: 0,
                left: 0,
                timer: null,
                maxTop: 0,
                maxLeft: 0,
                stepX: 3, 
                stepY: 3,
                show: true,
            }
        },
        components:{
            vHead, // vSidebar, vTags
        },
        methods:{
            formatDate: function (row, cloumn) {
                return util.formatDate.format(new Date(row), 'yyyy年MM月dd日');
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            move () {
              if (this.top >= this.maxTop || this.top < 0) {
                this.stepY = -this.stepY
              }
              if (this.left >= this.maxLeft || this.left < 0) {
                this.stepX = -this.stepX
              }

              this.top += this.stepY
              this.left += this.stepX
            },
            mouseover () {
              clearInterval(this.timer)
            },
            // 鼠标离开飘窗时恢复移动
            mouseout () {
              clearInterval(this.timer)
              this.timer = setInterval(() => {
                this.move()
              }, 20)
            },
            // 关闭飘窗
            close () {
              clearInterval(this.timer)
              this.show = false
            },
            // 窗口大小调整时重置飘窗规则
            onresize () {
              const that = this
              window.onresize = function () {
                that.init()
              }
            },
            openUrl() {
              window.open('https://mp.weixin.qq.com/s/LH5AnNxy9SimB6IXT8cuog');
            }
        },
        created(){
            bus.$on('collapse', msg => {
                this.collapse = msg;
            })

            // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
            bus.$on('tags', msg => {
                let arr = [];
                for(let i = 0, len = msg.length; i < len; i ++){
                    msg[i].name && arr.push(msg[i].name);
                }
                this.tagsList = arr;
            })
        },
        mounted() {
          this.maxTop = document.documentElement.clientHeight - 169;
          this.maxLeft = document.documentElement.clientWidth - 497;
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            this.move()
          }, 20)
          this.onresize()
        }
    }
</script>

<style>
.bay_window {
  font-size: 24px;
  /* background: url('../../assets/img/piaochuang.jpg') no-repeat; */
  background-color: rgb(46, 216, 123);
  background-size: cover;
  width: 497px; 
  height: 169px; 
  position: fixed; 
  z-index: 999;
  border-radius: 8px;
}
.link {
  cursor: pointer;
  color: #fff;
  text-decoration: underline;
  position: absolute;
  bottom: 0;
  padding: 20px;
}
.close_btn {
  cursor: pointer; 
  color: #fff; 
  font-size: 24px;
  /* font-weight: 600; */
  position: absolute;
  right: 12px;
  top: 10px;
  width: 50px;
  height: 40px;
}
</style>
